import { useEffect, useState } from "react"
import config from "../app-config"
import { log_user_action } from "../api/analyticsAPI";

export const logout = () => {
    let endpoint = config.endpoint + "/auth/logout"
    let response = fetch(endpoint, {
        credentials: "include",
        method: "POST",

    })
    localStorage.removeItem("user")
    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    window.location.href = "/"
}


export const analyticsCollector = async () => {
    await log_user_action({ device: "web" });
    return;
}

export const useFetchAuthorisation = (account_type) => {
    const [isAuthorised, setIsAuthorised] = useState(false);
    const [userRole, setUserRole] = useState("");

    useEffect(() => {
        const fetchAuthorisation = async () => {
            let current_location = encodeURIComponent(window.location.pathname)
            try {
                const endpoint = config.endpoint + "/auth/authorisation";
                const response = await fetch(endpoint, {
                    credentials: "include",
                    method: "POST",
                });
                const data = await response?.json();
                if (data.status === 200) {
                    sessionStorage.setItem("user", JSON.stringify(data.data));
                    setUserRole(data?.data?.account_type);
                    if (convertToRole(account_type) <= convertToRole(data?.data?.account_type)) {
                        setIsAuthorised(true);
                    } else {
                        window.location.href = `/auth/login?redirect=${current_location}`
                        setIsAuthorised(false);
                    }
                } else {
                    window.location.href = `/auth/login?redirect=${current_location}`
                    setIsAuthorised(false);
                }
            } catch (error) {
                setIsAuthorised(false);
            }
        };
        fetchAuthorisation();
    }, [account_type]);
    return { isAuthorised, userRole };
};


export const useFetchUserData = () => {
    const [userData, setUserData] = useState({});

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const endpoint = config.endpoint + "/auth/authorisation";
                const response = await fetch(endpoint, {
                    credentials: "include",
                    method: "POST",
                });
                const data = await response?.json();
                if (data.status === 200) {
                    sessionStorage.setItem("user", JSON.stringify(data.data));
                    setUserData(data.data);
                } else {
                    setUserData({});
                }
            } catch (error) {
                setUserData({});
            }
        };
        fetchUserData();
    }, []);
    return userData;
}


export const authorisationConverter = ({ requirement, current_role }) => {
    return convertToRole(requirement) <= convertToRole(current_role)
}

const convertToRole = (role) => {
    switch (role) {
        case "member":
            return 1;
        case "staff":
            return 2;
        case "manager":
            return 3;
        case "admin":
            return 4;
        case "superadmin":
            return 5;
        default:
            return 0;
    }
};